export const CameraPrincipalSx = {
    // border: '1px solid orange',
    width: '100%',
    height: '100%',
    padding: '2px'
}

export const CamerasSecundariasSx = {
    // border: '1px solid purple',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '2px',
    overflowY: 'auto',
    gap: 0.5
}

export const cameraSecundariaSx = {
    cursor: 'pointer',
    maxHeight: '33%',
    minHeight: '32%'
}
